import React, { Component} from 'react'
import { connect } from 'react-redux'
import Header from '../Header'
import Nav from '../Nav'
import ReactJson from 'react-json-view'
import  datos  from '../../lib/global/data'
import Button from 'react-bootstrap/Button'
import { Row, Col, Card } from 'react-bootstrap'
import { CopyBlock, dracula, ocean } from "react-code-blocks";
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'

class WebhooksCrear extends Component {
    constructor(){
        super()
        this.state = {
            code: '',
            language: ''
        }
    }
    render(){

        return(
            <div className="fluid">
       <Header/>   
<div className="container-fluid">
  <div className="row">
   <Nav/>
    <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4 leftauto">
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 className="h2">Crear webhook</h1>
      </div>



      <Row className="mb-5">
          <Col md={7}>


<h6><Button variant="warning" size="sm">POST</Button> /webhooks</h6>
<hr />

<h6>Parámetros </h6>
<Card className="mb-3">
    <Card.Body>
    <h6 className="mb-0">url <span style={{ fontWeight: 100 }}>String</span> <span className="text-danger">required</span> <span style={{ fontWeight: 100 }}>Url del endpoint destino. https obligatorio</span></h6>
        <hr/>
        <h6 className="mb-0">evento <span style={{ fontWeight: 100 }}>String</span> <span className="text-danger">required</span> <span style={{ fontWeight: 100 }}>Nombre del evento: <b>nuevo-pedido</b></span></h6>
        <hr/>
        <h6 className="mb-0">format <span style={{ fontWeight: 100 }}>String</span> <span className="text-primary">optional</span> <span style={{ fontWeight: 100 }}>Formato de la respuesta. default: json</span></h6>
        <hr/>
        <h6 className="mb-0">active <span style={{ fontWeight: 100 }}>Boolean</span> <span className="text-primary">optional</span> <span style={{ fontWeight: 100 }}>Verdadero si está activo, falso si está inactivo | default: true </span></h6>
    </Card.Body>
</Card>
<Card className="mb-3">
    <Card.Body>
        <h6 className="mb-0">STATUS <span className="text-success"><i className="text-success fas fa-check-circle"></i> 200</span> </h6>
    </Card.Body>
</Card>

<Card className="mb-3" style={{ background:'#0c0d0e' }}>
    <Card.Body>
    <ReactJson 
name={false}
  theme="brewer"
  indentWidth="4"
  src={{
    "active": true,
    "_id": "636e63fc1c21db4805e15b77",
    "propietario": "222222222",
    "evento": "nuevo-pedido",
    "url": "https://{url}",
    "format": "json",
    "createdAt": "2022-11-11T15:02:20.450Z",
    "updatedAt": "2022-11-11T15:02:20.450Z"
}} />
    </Card.Body>
</Card>


          </Col>

          <Col md={5}>
          <h4>Lenguajes</h4>

          <Tabs defaultActiveKey="php" id="uncontrolled-tab-example" className="mb-3">
<Tab eventKey="php" title="PHP">
    <h4>Guzzle</h4>
<CopyBlock
      text={`<?php
    $client = new \GuzzleHttp\Client();
    $response = $client->request('POST', '${datos.server}/webhooks', [
        'headers' => [
          'Accept' => 'application/json',
          'Authorization' => 'Bearer XXXX',
        ],
        'body' => json_encode($payload)
    ]);
    echo $response->getBody();
?>`}
      language="php"
      showLineNumbers={false}
      theme={ocean}
      customStyle={{ fontSize: 14 }}
    />
  </Tab>
<Tab eventKey="javascript" title="Javascript">

<CopyBlock
      text={`
   fetch('${datos.server}/webhooks', {
        method:'POST',
        body: JSON.stringify(payload),
        headers:{
            'Content-Type': 'application/json',
            'Authorization' => 'Bearer XXXX',
        }
    })
    .then(res => res.json())
    .then(respuesta => respuesta)
    .catch(error => error)
    `}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
      customStyle={{ fontSize: 14 }}

    />
  </Tab>
  
</Tabs>
          
<h4 className="mt-3">Header</h4>

<Card className="mb-3">
    <Card.Body>
        <h6 className="mb-0">Bearer <span style={{ fontWeight: 100 }}>String</span> <span className="text-danger">required</span></h6>
    </Card.Body>
</Card>

          </Col>
      </Row>
      
    </main>
  </div>
</div>
    </div>
        )
    }
}






export default WebhooksCrear